import { CognitoUserPool } from 'amazon-cognito-identity-js';
const poolData = {
  UserPoolId: 'us-east-1_4OGtf8oJU',
  ClientId: '45rohmfg8r002dttk1bopp8ljo',
};
const userPool = new CognitoUserPool(poolData);
export default userPool;
